import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledConfirmationModalWrapper = styled.div`
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;

  img {
    height: 105px;
    margin-bottom: 10px;
  }

  button {
    margin-top: auto;
  }

  ${themeMedia.maxTablet`
    padding: 10vh 24px 50px;
    
    button {
      width: 100%;
    }

    img {
      margin-bottom: 50px;
    }
  `}
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  max-width: 550px;
  align-items: center;
  justify-content: center;
  width: 100%;

  > * {
    text-align: center;
  }
`
